function normalizeProgram (program) {
  if (!program) return
  if (program.startsWith('RMS-OWN')) return 'RMS-OWN'
  if (program.startsWith('RMS-PRG')) return 'RMS-PRG'
  return program
}

module.exports = { normalizeProgram }
